import React from "react"
import "./ServiceOrders.less"
import ServiceOrdersTable from "./ServiceOrdersTable"

/**
 * ServiceOrders
 * @constructor
 */
const ServiceOrders: React.FC = () => {

  return (
    <div className="ServiceOrders">
      <ServiceOrdersTable />
    </div>
  )
}

export default ServiceOrders